<template>
  <transition name="fade">
    <div @click="close" class="mask" v-if="position.clientY > 0">
      <div
        class="rename-tag dark_box"
        :style="{
          top: position.clientY + clientY + 'px',
          display: position.clientY != 0 ? 'block' : 'none',
          left: clientX + 'px',
        }"
        @click.stop
      >
        <div class="flex align-center">
          <el-autocomplete
            class="inline-input"
            v-model="tag"
            :fetch-suggestions="querySearch"
            :trigger-on-focus="true"
            @select="handleSelect"
            popper-class="dark_box tag_autocomplete"
          ></el-autocomplete>
          <div class="btn" @click="save" v-loading="is_rename_running" :class="tag ? '' : 'disabled opacity2'">
            {{ this.$t('components.RenameTag.submit') }}
          </div>
        </div>
        <p>
          {{ this.$t('components.RenameTag.desc')
          }}<a target="_blank" :href="this.$t('components.RenameTag.link')">{{
            this.$t('components.RenameTag.link_text')
          }}</a>
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
import DBUtil from '../utils/DBUtil'
import { unxss, trim } from '../utils/utils'
import emitter from '../utils/eventbus.js'
export default {
  name: 'RenameTag',
  props: {},
  data() {
    return {
      position: {
        clientX: 0,
        clientY: 0,
      },
      tag: null,
      old_tag_name: null,
      is_rename_running: false,
      isTree: false,
      level: 0,
      parentNodeWidth: 0,
    }
  },

  computed: {
    clientY() {
      return this.isTree ? (this.position.clientY + 80 > document.body.offsetHeight ? 0 : 80) : 16
    },
    clientX() {
      return this.isTree
        ? this.$store.state.is_mobile
          ? 23
          : this.position.clientX - this.parentNodeWidth + 26
        : this.position.clientX
    },
    is_mobile() {
      return this.$store.state.is_mobile
    },
  },

  methods: {
    show: function (position, tag, isTree, level, parentNodeWidth) {
      let { clientX, clientY } = position

      if (window.innerWidth < 500) {
        clientX = clientX - 100
      }

      this.position = {
        clientX: isTree ? clientX : clientX - 30,
        clientY: clientY - 60,
      }
      this.tag = unxss(tag)
      this.old_tag_name = tag
      this.isTree = isTree
      this.level = level
      this.parentNodeWidth = parentNodeWidth
    },
    querySearch(queryString, cb) {
      // queryString 为空则直接返回[]
      if (!queryString.length) {
        cb([])
        return
      }
      const tags = this.$store.state.tags.map((tag) => {
        return {
          value: unxss(tag.name),
          label: unxss(tag.name),
        }
      })
      const results = queryString ? tags.filter(this.createFilter(queryString)) : tags
      cb(results)
    },
    createFilter(queryString) {
      return (tags) => {
        return tags.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1
      }
    },
    handleSelect(item) {
      this.tag = item.value
    },
    close: function () {
      // 判断鼠标是否选中了文字
      if (window.getSelection().toString()) {
        return
      }
      this.tag = null
      this.position = {
        clientX: 0,
        clientY: 0,
      }
    },
    save: function () {
      if (!this.tag) {
        return
      }
      // 判断 tag 是否包含#
      if (this.tag.indexOf('#') > -1) {
        this.$message.error(this.$t('components.TagTree.messages.rename_tag_tips'))
        return
      }

      if (this.tag == this.old_tag_name || this.is_rename_running) {
        return // 没有改名，不用后续处理
      }

      this.is_rename_running = true
      this.$message.success(this.$t('components.TagTree.messages.waiting'))
      let vm = this

      let newTag = trim(vm.tag)

      // 把&转义
      if (newTag.indexOf('&') > -1) {
        newTag = newTag.replace(/&/g, '&amp;')
      }

      DBUtil.renameTag(vm.old_tag_name, newTag).then((result) => {
        vm.is_rename_running = false
        if (result) {
          vm.$store.commit('setSelectedTag', newTag)
          // 重加载置顶标签
          vm.$store.dispatch('loadPinnedTags')
          // 修改地址栏?tag=xxx 为新的tag
          // 如果地址栏中没有tag参数，则不修改
          if (vm.$route.query.tag == vm.old_tag_name) {
            vm.$router.replace({
              query: {
                tag: newTag,
              },
            })
          }

          emitter.emit('tag-rename')

          vm.close()
        } else {
          vm.$message.error(vm.$t('components.TagTree.messages.reject'))
        }
      })
    },
  },
}
</script>
<style scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.rename-tag {
  position: absolute;
  width: 250px;
  height: 94px;
  padding: 16px;
  box-sizing: border-box;
  background: var(--dark-box-bg);
  border: 1px solid var(--dark-box-border);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.inline-input {
  width: 160px;
  height: 33px;
  line-height: 33px;
}
.inline-input /deep/ .el-input__inner {
  height: 33px;
  line-height: 33px;
}

.inline-input /deep/ .el-autocomplete-suggestion li {
  background: #252729 !important;
}
.btn {
  margin-left: 10px;
  border-radius: 3px;
  width: 52px;
  height: 32px;
  line-height: 32px;
  display: inline-block;
  font-size: 12px;
  cursor: pointer;
  text-align: center;
  background: #70b991;
  color: #ffffff;
}
p {
  color: #9d9d9d;
  font-size: 12px;
  margin-top: 10px;
}
a {
  color: #5f84ef;
  text-decoration: none;
}
body.dark_mode p {
  color: #646464;
}

.inline-input /deep/ .el-input.is-active .el-input__inner,
.inline-input /deep/ .el-input__inner:focus {
  border: 1px solid #55bb8e;
  outline: 0;
}
</style>
